import { Typography } from "antd";
import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";

export const StyledDebtCardSectionTop = styled(FlexContainer)`
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #313131;
    padding-bottom: 16px;
    gap: 12px;
`;

export const StyledDebtCardSection = styled(FlexContainer)`
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #313131;
    padding: 16px 0;
    gap: 12px;
`;

export const StyledDebtCardSectionBottom = styled(FlexContainer)`
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    gap: 12px;
`;

export const StyledDebtLabel = styled(Typography)<{ $isDanger?: boolean }>`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;

    && {
        color: ${(props) =>
            props.$isDanger
                ? props.theme.dangerTypographyColor
                : props.theme.secondaryTypographyColor};
    }
`;

export const StyledDebtValue = styled(Typography)<{ $isDanger?: boolean }>`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;

    && {
        color: ${(props) =>
            props.$isDanger
                ? props.theme.dangerTypographyColor
                : props.theme.secondaryTypographyColor};
    }
`;
